export const mainContainer = {
  margin: "25px 0 0",
  overflow: "visible", // Allow floats to continue across sections
  width: "100%",
  boxSizing: "border-box",
  "@media(max-width: 1023px)": {
    width: "100%",
    margin: "20px 0 0",
  },
  "@media(min-width: 1024px)": {
    width: "100%",
  },
};

export const localeTitle = {
  color: "#003755",
  fontSize: "1em",
  display: "block",
  fontWeight: "bold",
};

// Image Card Container with border and background
export const imageCard = {
  backgroundColor: "#f9f9f9",
  border: "1px solid #e0e0e0",
  borderRadius: "8px",
  padding: "20px",
  marginBottom: "25px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  "@media(max-width: 768px)": {
    padding: "15px",
    marginBottom: "20px",
  },
};

// Image Title - Bold and Centered
export const imageTitle = {
  fontSize: "1.1em",
  fontWeight: "bold",
  color: "#003755",
  textAlign: "center",
  marginBottom: "15px",
  lineHeight: "1.4em",
  "@media(max-width: 768px)": {
    fontSize: "1em",
    marginBottom: "12px",
  },
};

// Image Caption - Italic and Smaller Font
export const imageCaption = {
  fontSize: "0.85em",
  fontStyle: "italic",
  color: "#666",
  textAlign: "center",
  marginTop: "10px",
  lineHeight: "1.3em",
  padding: "0 10px",
  "@media(max-width: 768px)": {
    fontSize: "0.8em",
    marginTop: "8px",
  },
};

// Regular Image - Full Width (Mobile: 100%)
export const image = {
  maxWidth: "100%",
  width: "100%",
  height: "auto",
  display: "block",
  margin: "0 auto",
  borderRadius: "4px",
  "@media(max-width: 768px)": {
    width: "100%",
  },
};

// Floated Image - Responsive widths (Email: 48%, Web: 50%)
export const imageFloated = {
  maxWidth: "100%",
  height: "auto",
  borderRadius: "4px",
  margin: "0 15px 15px 0",
  // Web viewport (Desktop)
  "@media(min-width: 1024px)": {
    width: "50%",
    float: "left",
  },
  // Email/Tablet viewport
  "@media(min-width: 769px) and (max-width: 1023px)": {
    width: "48%",
    float: "left",
  },
  // Mobile viewport
  "@media(max-width: 768px)": {
    width: "100%",
    float: "none",
    margin: "0 auto 15px",
  },
};

export const summaryText = {
  fontSize: ".875em",
  lineHeight: "1.275em",
  margin: "10px 0 20px",
  color: "#003755",
  padding: "0",
  overflow: "visible", // Allow floats to work properly
  "& img": {
    maxWidth: "100%",
    width: "auto",
    height: "auto",
    display: "block",
    margin: "10px 0",
    boxSizing: "border-box",
  },
  // Regular images (without wrapper) - inline display
  "& img": {
    maxWidth: "100%",
    height: "auto",
    display: "inline-block",
    verticalAlign: "middle",
  },
  // Allow paragraphs to flow around floating wrappers
  "& p": {
    clear: "none",
  },
  // Clean wrapper for images with title/caption - Professional, document-like
  // Default: left-aligned (matching left position behavior)
  "& .image-with-caption-wrapper": {
    float: "left",
    maxWidth: "48%",
    marginRight: "24px",
    marginLeft: "0",
    marginTop: "4px",
    marginBottom: "16px",
    padding: "0",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "0",
    boxShadow: "none",
    // Desktop layout
    "@media(min-width: 769px)": {
      maxWidth: "48%",
      marginRight: "24px",
    },
    // Tablet layout
    "@media(max-width: 991px)": {
      maxWidth: "45%",
      marginRight: "20px",
    },
    // Mobile layout
    "@media(max-width: 768px)": {
      margin: "24px 0",
      padding: "0",
      float: "none !important",
      maxWidth: "100%",
    },
  },
  // Left-aligned floating wrapper (explicit)
  "& .image-with-caption-wrapper[data-position='left']": {
    float: "left",
    maxWidth: "48%",
    marginRight: "24px",
    marginLeft: "0",
    marginTop: "4px",
    marginBottom: "16px",
    "@media(max-width: 991px)": {
      maxWidth: "45%",
      marginRight: "20px",
    },
    "@media(max-width: 768px)": {
      float: "none !important",
      maxWidth: "100%",
      margin: "24px 0",
    },
  },
  // Right-aligned floating wrapper
  "& .image-with-caption-wrapper[data-position='right']": {
    float: "right",
    maxWidth: "48%",
    marginLeft: "24px",
    marginRight: "0",
    marginTop: "4px",
    marginBottom: "16px",
    "@media(max-width: 991px)": {
      maxWidth: "45%",
      marginLeft: "20px",
    },
    "@media(max-width: 768px)": {
      float: "none !important",
      maxWidth: "100%",
      margin: "24px 0",
    },
  },
  // Center-aligned wrapper
  "& .image-with-caption-wrapper[data-position='center']": {
    float: "none",
    margin: "32px auto",
    maxWidth: "100%",
    textAlign: "center",
    "@media(max-width: 768px)": {
      margin: "24px 0",
    },
  },
  // Image title - Clean, professional heading (like PDF)
  "& .image-caption-title": {
    fontSize: "15px",
    fontWeight: "600",
    color: "#2c2c2c",
    textAlign: "right",
    marginBottom: "10px",
    lineHeight: "1.4",
    letterSpacing: "normal",
    fontFamily:
      "'Danske Text v2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    padding: "0",
    whiteSpace: "pre-line",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    display: "block",
    // Desktop
    "@media(min-width: 769px)": {
      fontSize: "16px",
      marginBottom: "12px",
    },
    // Tablet
    "@media(max-width: 991px)": {
      fontSize: "15px",
      marginBottom: "10px",
    },
    // Mobile
    "@media(max-width: 768px)": {
      fontSize: "14px",
      marginBottom: "8px",
    },
  },
  // Image styling - Clean, no effects (PDF-like)
  "& .image-with-caption-image": {
    maxWidth: "100%",
    width: "100%",
    height: "auto",
    display: "block",
    margin: "0 auto",
    borderRadius: "0",
    boxShadow: "none",
    border: "1px solid #ddd",
    objectFit: "contain",
    backgroundColor: "transparent",
    "@media(max-width: 768px)": {
      borderRadius: "0",
    },
  },
  // Caption text - Clean, document-style
  "& .image-caption-text": {
    fontSize: "13px",
    fontStyle: "italic",
    color: "#666666",
    textAlign: "right",
    marginTop: "10px",
    lineHeight: "1.5",
    padding: "0",
    fontFamily:
      "'Danske Text v2', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    letterSpacing: "normal",
    whiteSpace: "pre-line",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    display: "block",
    // Desktop
    "@media(min-width: 769px)": {
      fontSize: "14px",
      marginTop: "12px",
      lineHeight: "1.5",
    },
    // Tablet
    "@media(max-width: 991px)": {
      fontSize: "13px",
      marginTop: "10px",
    },
    // Mobile
    "@media(max-width: 768px)": {
      fontSize: "12px",
      marginTop: "8px",
    },
  },
};

export const padding0 = {
  padding: "0",
  "@media(max-width: 768px)": {
    padding: "0 18px", // Add padding on mobile to prevent text cutoff
  },
};
